// src/components/ConfidenceIndicator.js (Create this new file)
import React from 'react';
import { getConfidenceColor } from '../utils/confidenceUtils';

const ConfidenceIndicator = ({ confidence }) => {
  if (confidence === null) {
    return null; // Don't show indicator if no confidence score
  }

  const colorClass = getConfidenceColor(confidence);

  return (
    <span
      className={`inline-block w-2.5 h-2.5 rounded-full ml-2 align-middle ${colorClass}`}
      title={`Confidence: ${confidence}%`} // Tooltip for exact score
    />
  );
};

export default ConfidenceIndicator;